module.exports = __webpack_public_path__ + "img/studioManager.9e97468a.gif";